import { IconClassificationItem } from "@/enums/enums";

export function GetIconList() {
  const iconList = [
    { iconName: "icon-allocation01", iconType: IconClassificationItem.GraphBar1 },
    { iconName: "icon-allocation02", iconType: IconClassificationItem.Pin1 },
    { iconName: "icon-allocation03", iconType: IconClassificationItem.Star1 },
    { iconName: "icon-allocation04", iconType: IconClassificationItem.GraphBar2 },
    { iconName: "icon-allocation05", iconType: IconClassificationItem.Percentage },
    { iconName: "icon-allocation06", iconType: IconClassificationItem.Wallet },
    { iconName: "icon-allocation07", iconType: IconClassificationItem.Document },
    { iconName: "icon-allocation08", iconType: IconClassificationItem.Building },
    { iconName: "icon-allocation09", iconType: IconClassificationItem.Suitcase },
    { iconName: "icon-allocation10", iconType: IconClassificationItem.Location },
    { iconName: "icon-allocation11", iconType: IconClassificationItem.Plane },
    { iconName: "icon-allocation12", iconType: IconClassificationItem.PieChart },
    { iconName: "icon-allocation13", iconType: IconClassificationItem.MultiUsers },
    { iconName: "icon-allocation14", iconType: IconClassificationItem.Shopping },
    { iconName: "icon-allocation15", iconType: IconClassificationItem.Merchant },
    { iconName: "icon-allocation16", iconType: IconClassificationItem.Box },
    { iconName: "icon-allocation17", iconType: IconClassificationItem.MailBox },
    { iconName: "icon-allocation18", iconType: IconClassificationItem.Receipt },
    { iconName: "icon-allocation19", iconType: IconClassificationItem.Approve },
    { iconName: "icon-allocation20", iconType: IconClassificationItem.Windmill },
    { iconName: "icon-allocation21", iconType: IconClassificationItem.Lock },
    { iconName: "icon-allocation22", iconType: IconClassificationItem.Study },
    { iconName: "icon-allocation23", iconType: IconClassificationItem.Folder },
    { iconName: "icon-allocation24", iconType: IconClassificationItem.PaperPlane },
    { iconName: "icon-allocation25", iconType: IconClassificationItem.Goal },
    { iconName: "icon-allocation26", iconType: IconClassificationItem.ArrowRight },
    { iconName: "icon-allocation27", iconType: IconClassificationItem.Book },
    { iconName: "icon-allocation28", iconType: IconClassificationItem.Wrench },
    { iconName: "icon-allocation29", iconType: IconClassificationItem.Destination },
    { iconName: "icon-allocation30", iconType: IconClassificationItem.Coin },
    { iconName: "icon-allocation31", iconType: IconClassificationItem.Car },
    { iconName: "icon-allocation32", iconType: IconClassificationItem.Note },
    { iconName: "icon-allocation33", iconType: IconClassificationItem.Gift },
    { iconName: "icon-allocation34", iconType: IconClassificationItem.Education },
    { iconName: "icon-allocation35", iconType: IconClassificationItem.Handshake },
    { iconName: "icon-allocation36", iconType: IconClassificationItem.Health },
    { iconName: "icon-allocation37", iconType: IconClassificationItem.Home },
    { iconName: "icon-allocation38", iconType: IconClassificationItem.Idea },
    { iconName: "icon-allocation39", iconType: IconClassificationItem.Annouce },
    { iconName: "icon-allocation40", iconType: IconClassificationItem.Meeting },
    { iconName: "icon-allocation41", iconType: IconClassificationItem.Pint2 },
    { iconName: "icon-allocation42", iconType: IconClassificationItem.TreeChart },
    { iconName: "icon-allocation43", iconType: IconClassificationItem.Brush },
    { iconName: "icon-allocation44", iconType: IconClassificationItem.Piggy },
    { iconName: "icon-allocation45", iconType: IconClassificationItem.Achrive },
    { iconName: "icon-allocation46", iconType: IconClassificationItem.Calculator },
    { iconName: "icon-allocation47", iconType: IconClassificationItem.Subway },
    { iconName: "icon-allocation48", iconType: IconClassificationItem.Label },
    { iconName: "icon-allocation49", iconType: IconClassificationItem.Shopee },
    { iconName: "icon-allocation50", iconType: IconClassificationItem.Lazada },
    { iconName: "icon-allocation51", iconType: IconClassificationItem.Facebook },
    { iconName: "icon-allocation52", iconType: IconClassificationItem.Line },
    { iconName: "icon-allocation53", iconType: IconClassificationItem.Internet },
    { iconName: "icon-allocation54", iconType: IconClassificationItem.Laptop },
  ];
  return iconList;
}
